import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './RegionManagement.css';
import { API_BASE_URL } from '../api/axiosConfig';
const RegionManagement = () => {
    const [regionCodes, setRegionCodes] = useState([]);
    const [excludeKeywords, setExcludeKeywords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [editingRegion, setEditingRegion] = useState(null);
    const [testAddresses, setTestAddresses] = useState('');
    const [testResults, setTestResults] = useState([]);
    // 폼 데이터
    const [formData, setFormData] = useState({
        region_code: '',
        region_name: '',
        min_amount: 0,
        color_code: '#FFFFFF',
        display_order: 0,
        is_active: true,
        keywords: []
    });
    // 데이터 로드
    const loadData = async () => {
        setLoading(true);
        try {
            const [regionResponse, excludeResponse] = await Promise.all([
                axios.get(`${API_BASE_URL}/api/regions/codes`),
                axios.get(`${API_BASE_URL}/api/regions/exclude-keywords`)
            ]);
            setRegionCodes(regionResponse.data.data);
            setExcludeKeywords(excludeResponse.data.data);
        }
        catch (error) {
            console.error('데이터 로드 오류:', error);
            alert('데이터 로드 중 오류가 발생했습니다.');
        }
        finally {
            setLoading(false);
        }
    };
    // 지역코드 상세 조회
    const loadRegionDetail = async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/regions/codes/${id}`);
            return response.data.data;
        }
        catch (error) {
            console.error('지역코드 상세 조회 오류:', error);
            throw error;
        }
    };
    // 새 지역코드 추가
    const handleAdd = () => {
        setEditingRegion(null);
        setFormData({
            region_code: '',
            region_name: '',
            min_amount: 0,
            color_code: '#FFFFFF',
            display_order: regionCodes.length + 1,
            is_active: true,
            keywords: []
        });
        setShowModal(true);
    };
    // 지역코드 수정
    const handleEdit = async (region) => {
        try {
            const detail = await loadRegionDetail(region.id);
            setEditingRegion(detail);
            setFormData({
                region_code: detail.region_code,
                region_name: detail.region_name,
                min_amount: detail.min_amount,
                color_code: detail.color_code,
                display_order: detail.display_order,
                is_active: detail.is_active,
                keywords: detail.keywords || []
            });
            setShowModal(true);
        }
        catch (error) {
            alert('지역코드 상세 정보를 불러오는데 실패했습니다.');
        }
    };
    // 지역코드 저장
    const handleSave = async () => {
        var _a, _b;
        try {
            if (editingRegion) {
                // 수정
                await axios.put(`${API_BASE_URL}/api/regions/codes/${editingRegion.id}`, formData);
                alert('지역코드가 성공적으로 수정되었습니다.');
            }
            else {
                // 생성
                await axios.post(`${API_BASE_URL}/api/regions/codes`, formData);
                alert('지역코드가 성공적으로 생성되었습니다.');
            }
            setShowModal(false);
            loadData();
        }
        catch (error) {
            console.error('저장 오류:', error);
            alert(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || '저장 중 오류가 발생했습니다.');
        }
    };
    // 지역코드 삭제
    const handleDelete = async (id, regionCode) => {
        var _a, _b;
        if (!window.confirm(`'${regionCode}' 지역코드를 삭제하시겠습니까?\n관련된 모든 키워드도 함께 삭제됩니다.`)) {
            return;
        }
        try {
            await axios.delete(`${API_BASE_URL}/api/regions/codes/${id}`);
            alert('지역코드가 성공적으로 삭제되었습니다.');
            loadData();
        }
        catch (error) {
            console.error('삭제 오류:', error);
            alert(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || '삭제 중 오류가 발생했습니다.');
        }
    };
    // 키워드 추가
    const addKeyword = () => {
        setFormData({
            ...formData,
            keywords: [
                ...formData.keywords,
                {
                    keyword: '',
                    keyword_type: 'DISTRICT',
                    priority: 5,
                    is_active: true
                }
            ]
        });
    };
    // 키워드 삭제
    const removeKeyword = (index) => {
        setFormData({
            ...formData,
            keywords: formData.keywords.filter((_, i) => i !== index)
        });
    };
    // 키워드 수정
    const updateKeyword = (index, field, value) => {
        const updatedKeywords = [...formData.keywords];
        updatedKeywords[index] = { ...updatedKeywords[index], [field]: value };
        setFormData({ ...formData, keywords: updatedKeywords });
    };
    // 제외 키워드 추가
    const addExcludeKeyword = async () => {
        var _a, _b;
        const keyword = prompt('추가할 제외 키워드를 입력하세요:');
        if (!keyword)
            return;
        const description = prompt('설명을 입력하세요 (선택사항):') || '';
        try {
            await axios.post(`${API_BASE_URL}/api/regions/exclude-keywords`, {
                keyword,
                description
            });
            alert('제외 키워드가 추가되었습니다.');
            loadData();
        }
        catch (error) {
            alert(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || '제외 키워드 추가 중 오류가 발생했습니다.');
        }
    };
    // 제외 키워드 삭제
    const deleteExcludeKeyword = async (id, keyword) => {
        var _a, _b;
        if (!window.confirm(`'${keyword}' 제외 키워드를 삭제하시겠습니까?`))
            return;
        try {
            await axios.delete(`${API_BASE_URL}/api/regions/exclude-keywords/${id}`);
            alert('제외 키워드가 삭제되었습니다.');
            loadData();
        }
        catch (error) {
            alert(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || '제외 키워드 삭제 중 오류가 발생했습니다.');
        }
    };
    // 지역코드 테스트
    const testRegionCodes = async () => {
        if (!testAddresses.trim()) {
            alert('테스트할 주소를 입력하세요.');
            return;
        }
        const addresses = testAddresses.split('\n').map(addr => addr.trim()).filter(addr => addr);
        try {
            setLoading(true);
            const response = await axios.post(`${API_BASE_URL}/api/regions/test`, { addresses });
            setTestResults(response.data.data);
        }
        catch (error) {
            console.error('테스트 오류:', error);
            alert('지역코드 테스트 중 오류가 발생했습니다.');
        }
        finally {
            setLoading(false);
        }
    };
    // 캐시 새로고침
    const refreshCache = async () => {
        try {
            await axios.post(`${API_BASE_URL}/api/regions/refresh-cache`);
            alert('캐시가 성공적으로 새로고침되었습니다.');
        }
        catch (error) {
            alert('캐시 새로고침 중 오류가 발생했습니다.');
        }
    };
    useEffect(() => {
        loadData();
    }, []);
    return (_jsxs("div", { className: "region-management", children: [_jsxs("div", { className: "header", children: [_jsxs("div", { children: [_jsx("h1", { children: "\uC9C0\uC5ED \uCF54\uB4DC \uAD00\uB9AC" }), _jsx("p", { className: "page-description", children: "\uBC30\uC1A1 \uAD8C\uC5ED, \uC81C\uC678 \uD0A4\uC6CC\uB4DC, \uC8FC\uC18C \uD14C\uC2A4\uD2B8 \uACB0\uACFC\uB97C \uD55C \uD654\uBA74\uC5D0\uC11C \uAD00\uB9AC\uD569\uB2C8\uB2E4." })] }), _jsxs("div", { className: "actions", children: [_jsx("button", { onClick: loadData, disabled: loading, children: loading ? '로딩중...' : '새로고침' }), _jsx("button", { onClick: refreshCache, className: "refresh-btn", children: "\uCE90\uC2DC \uC0C8\uB85C\uACE0\uCE68" }), _jsx("button", { onClick: handleAdd, className: "add-btn", children: "+ \uC9C0\uC5ED\uCF54\uB4DC \uCD94\uAC00" })] })] }), _jsxs("div", { className: "stats-cards", children: [_jsxs("div", { className: "stats-card", children: [_jsx("h3", { children: "\uCD1D \uC9C0\uC5ED\uCF54\uB4DC" }), _jsxs("p", { children: [regionCodes.length, "\uAC1C"] })] }), _jsxs("div", { className: "stats-card", children: [_jsx("h3", { children: "\uD65C\uC131 \uC9C0\uC5ED\uCF54\uB4DC" }), _jsxs("p", { children: [regionCodes.filter(r => r.is_active).length, "\uAC1C"] })] }), _jsxs("div", { className: "stats-card", children: [_jsx("h3", { children: "\uCD1D \uD0A4\uC6CC\uB4DC" }), _jsxs("p", { children: [regionCodes.reduce((sum, r) => sum + r.keyword_count, 0), "\uAC1C"] })] }), _jsxs("div", { className: "stats-card", children: [_jsx("h3", { children: "\uC81C\uC678 \uD0A4\uC6CC\uB4DC" }), _jsxs("p", { children: [excludeKeywords.filter(k => k.is_active).length, "\uAC1C"] })] })] }), _jsxs("div", { className: "table-section", children: [_jsx("h2", { children: "\uC9C0\uC5ED\uCF54\uB4DC \uBAA9\uB85D" }), _jsx("div", { className: "table-container", children: _jsxs("table", { className: "region-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "\uC21C\uC11C" }), _jsx("th", { children: "\uC9C0\uC5ED\uCF54\uB4DC" }), _jsx("th", { children: "\uC9C0\uC5ED\uBA85" }), _jsx("th", { children: "\uCD5C\uC18C\uAE08\uC561" }), _jsx("th", { children: "\uC0C9\uC0C1" }), _jsx("th", { children: "\uD0A4\uC6CC\uB4DC \uC218" }), _jsx("th", { children: "\uC0C1\uD0DC" }), _jsx("th", { children: "\uAD00\uB9AC" })] }) }), _jsx("tbody", { children: regionCodes.map((region) => (_jsxs("tr", { className: !region.is_active ? 'inactive' : '', children: [_jsx("td", { children: region.display_order }), _jsx("td", { className: "region-code", children: region.region_code }), _jsx("td", { children: region.region_name }), _jsxs("td", { className: "amount", children: [region.min_amount.toLocaleString(), "\uC6D0"] }), _jsx("td", { children: _jsx("div", { className: "color-preview", style: { backgroundColor: region.color_code }, children: region.color_code }) }), _jsxs("td", { className: "keyword-count", children: [region.keyword_count, "\uAC1C"] }), _jsx("td", { children: _jsx("span", { className: `status ${region.is_active ? 'active' : 'inactive'}`, children: region.is_active ? '활성' : '비활성' }) }), _jsxs("td", { children: [_jsx("button", { onClick: () => handleEdit(region), className: "edit-btn", children: "\uC218\uC815" }), _jsx("button", { onClick: () => handleDelete(region.id, region.region_code), className: "delete-btn", children: "\uC0AD\uC81C" })] })] }, region.id))) })] }) })] }), _jsxs("div", { className: "exclude-keywords-section", children: [_jsxs("div", { className: "section-header", children: [_jsx("h2", { children: "\uC81C\uC678 \uD0A4\uC6CC\uB4DC" }), _jsx("button", { onClick: addExcludeKeyword, className: "add-btn", children: "+ \uC81C\uC678 \uD0A4\uC6CC\uB4DC \uCD94\uAC00" })] }), _jsx("div", { className: "exclude-keywords-list", children: excludeKeywords.map((keyword) => (_jsxs("div", { className: "exclude-keyword-item", children: [_jsx("span", { className: "keyword", children: keyword.keyword }), _jsx("span", { className: "description", children: keyword.description }), _jsx("button", { onClick: () => deleteExcludeKeyword(keyword.id, keyword.keyword), className: "delete-btn small", children: "\uC0AD\uC81C" })] }, keyword.id))) })] }), _jsxs("div", { className: "test-section", children: [_jsx("h2", { children: "\uC9C0\uC5ED\uCF54\uB4DC \uD14C\uC2A4\uD2B8" }), _jsxs("div", { className: "test-input", children: [_jsx("textarea", { value: testAddresses, onChange: (e) => setTestAddresses(e.target.value), placeholder: "\uD14C\uC2A4\uD2B8\uD560 \uC8FC\uC18C\uB97C \uD55C \uC904\uC529 \uC785\uB825\uD558\uC138\uC694...", rows: 5 }), _jsx("button", { onClick: testRegionCodes, disabled: loading, children: "\uD14C\uC2A4\uD2B8 \uC2E4\uD589" })] }), testResults.length > 0 && (_jsxs("div", { className: "test-results", children: [_jsx("h3", { children: "\uD14C\uC2A4\uD2B8 \uACB0\uACFC" }), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "\uC8FC\uC18C" }), _jsx("th", { children: "\uC9C0\uC5ED\uCF54\uB4DC" }), _jsx("th", { children: "\uCD5C\uC18C\uAE08\uC561" }), _jsx("th", { children: "\uC218\uB3C4\uAD8C\uC5EC\uBD80" }), _jsx("th", { children: "\uC0C9\uC0C1" })] }) }), _jsx("tbody", { children: testResults.map((result, index) => (_jsxs("tr", { children: [_jsx("td", { children: result.address }), _jsx("td", { className: "region-code", children: result.regionCode }), _jsxs("td", { className: "amount", children: [result.minAmount.toLocaleString(), "\uC6D0"] }), _jsx("td", { children: _jsx("span", { className: `status ${result.isMetropolitan ? 'active' : 'inactive'}`, children: result.isMetropolitan ? '수도권' : '기타지역' }) }), _jsx("td", { children: _jsx("div", { className: "color-preview", style: { backgroundColor: result.colorCode }, children: result.colorCode }) })] }, index))) })] })] }))] }), showModal && (_jsx("div", { className: "modal-overlay", children: _jsxs("div", { className: "modal", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h2", { children: editingRegion ? '지역코드 수정' : '지역코드 추가' }), _jsx("button", { onClick: () => setShowModal(false), className: "close-btn", children: "\u2715" })] }), _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { children: "\uC9C0\uC5ED\uCF54\uB4DC" }), _jsx("input", { type: "text", value: formData.region_code, onChange: (e) => setFormData({ ...formData, region_code: e.target.value }), placeholder: "\uC608: \uC11C\uC6B81\uAD6C\uC5ED" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "\uC9C0\uC5ED\uBA85" }), _jsx("input", { type: "text", value: formData.region_name, onChange: (e) => setFormData({ ...formData, region_name: e.target.value }), placeholder: "\uC608: \uC11C\uC6B81\uAD6C\uC5ED (\uAC15\uC11C/\uC591\uCC9C/\uAD6C\uB85C/\uC601\uB4F1\uD3EC/\uB9C8\uD3EC)" })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { children: "\uCD5C\uC18C\uAE08\uC561" }), _jsx("input", { type: "number", value: formData.min_amount, onChange: (e) => setFormData({ ...formData, min_amount: Number(e.target.value) }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "\uC0C9\uC0C1" }), _jsx("input", { type: "color", value: formData.color_code, onChange: (e) => setFormData({ ...formData, color_code: e.target.value }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "\uD45C\uC2DC\uC21C\uC11C" }), _jsx("input", { type: "number", value: formData.display_order, onChange: (e) => setFormData({ ...formData, display_order: Number(e.target.value) }) })] })] }), _jsx("div", { className: "form-group", children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: formData.is_active, onChange: (e) => setFormData({ ...formData, is_active: e.target.checked }) }), "\uD65C\uC131\uD654"] }) }), _jsxs("div", { className: "keywords-section", children: [_jsxs("div", { className: "keywords-header", children: [_jsx("h3", { children: "\uAC80\uC0C9 \uD0A4\uC6CC\uB4DC" }), _jsx("button", { type: "button", onClick: addKeyword, className: "add-btn small", children: "+ \uD0A4\uC6CC\uB4DC \uCD94\uAC00" })] }), formData.keywords.map((keyword, index) => (_jsxs("div", { className: "keyword-row", children: [_jsx("input", { type: "text", value: keyword.keyword, onChange: (e) => updateKeyword(index, 'keyword', e.target.value), placeholder: "\uD0A4\uC6CC\uB4DC" }), _jsxs("select", { value: keyword.keyword_type, onChange: (e) => updateKeyword(index, 'keyword_type', e.target.value), children: [_jsx("option", { value: "DISTRICT", children: "\uAD6C/\uAD70" }), _jsx("option", { value: "CITY", children: "\uC2DC" }), _jsx("option", { value: "PROVINCE", children: "\uB3C4/\uAD11\uC5ED\uC2DC" }), _jsx("option", { value: "EXACT", children: "\uC815\uD655\uC77C\uCE58" })] }), _jsx("input", { type: "number", value: keyword.priority, onChange: (e) => updateKeyword(index, 'priority', Number(e.target.value)), placeholder: "\uC6B0\uC120\uC21C\uC704", min: "1", max: "10" }), _jsx("button", { type: "button", onClick: () => removeKeyword(index), className: "delete-btn small", children: "\uC0AD\uC81C" })] }, index)))] })] }), _jsxs("div", { className: "modal-footer", children: [_jsx("button", { onClick: () => setShowModal(false), className: "cancel-btn", children: "\uCDE8\uC18C" }), _jsx("button", { onClick: handleSave, className: "save-btn", children: "\uC800\uC7A5" })] })] }) }))] }));
};
export default RegionManagement;
